
<div class="d-pdf" >
  <div id="app" class="app"  ></div>
  <div class="close">
    <span>x</span>
  </div>
</div>
